document.addEventListener("DOMContentLoaded", function () {
  if (window.__tabs_initialized) return;
  window.__tabs_initialized = true;

  const tabLinks = document.querySelectorAll(".js-tab-link");
  if (!tabLinks.length) return;

  tabLinks.forEach(function (tabLink) {
    tabLink.addEventListener("click", function (e) {
      e.preventDefault();

      const tabsWrapper =
        tabLink.closest(".tabs-wrapper") || tabLink.parentElement.parentElement;
      if (!tabsWrapper) return;

      tabsWrapper.querySelectorAll(".js-tab-link").forEach(function (link) {
        link.classList.remove("active");
      });
      tabLink.classList.add("active");

      const tabContainer = tabsWrapper.parentElement;

      tabContainer.querySelectorAll(".js-tab-content").forEach(function (content) {
        content.classList.remove("tab-content__active", "tab-content__show");
      });

      const targetContent = tabContainer.querySelector(
        `.js-tab-content[data-id='${tabLink.getAttribute("data-id")}']`
      );
      if (targetContent) {
        targetContent.classList.add("tab-content__active");
        setTimeout(function () {
          targetContent.classList.add("tab-content__show");
        }, 50);
      }
    });
  });
});